import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Box,
  Button,
  Container,
  Group,
  Paper,
  SimpleGrid,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from '@mantine/core'
import {
  ClipboardList,
  Users,
  BookOpen,
  GraduationCap,
  ChevronRight,
  LayoutList,
} from 'lucide-react'
import { useAuth } from '../../context/AuthContext'

export function TutorDashboard() {
  const { user } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (user && (user.role === 'tutor' || user.role === 'god') && user.onboarding_completed === false) {
      navigate('/onboarding', { replace: true })
    }
  }, [user, navigate])

  const cards = [
    {
      title: 'Rosters',
      description: 'Manage student rosters',
      icon: <Users size={24} />,
      color: 'blue',
      path: '/tutor/rosters',
    },
    {
      title: 'Assignments',
      description: 'Create and manage assignments',
      icon: <BookOpen size={24} />,
      color: 'grape',
      path: '/tutor/assignments',
    },
    {
      title: 'Grading',
      description: 'Grade student submissions',
      icon: <GraduationCap size={24} />,
      color: 'orange',
      path: '/tutor/grading',
    },
    {
      title: 'Mocks',
      description: 'SAT mock tests',
      icon: <ClipboardList size={24} />,
      color: 'grapefruit',
      path: '/tutor/mock',
    },
    {
      title: 'Student Plan',
      description: 'Create learning plans for students',
      icon: <LayoutList size={24} />,
      color: 'teal',
      path: '/tutor/plans',
    },
  ]

  return (
    <Container size="lg" py="xl">
      <Stack gap="lg">
        <Box>
          <Title order={2} c="var(--sat-text)">Tutor Dashboard</Title>
          <Text c="var(--sat-text-muted)" mt={4}>Welcome back, {user?.user_name}</Text>
        </Box>

        <SimpleGrid cols={{ base: 1, sm: 2, md: 4 }} spacing="md">
          {cards.map((card) => (
            <Paper
              key={card.title}
              radius="xl"
              p="lg"
              withBorder
              style={{
                background: 'var(--sat-surface)',
                borderColor: 'var(--sat-border)',
                cursor: 'pointer',
                transition: 'transform 0.15s, box-shadow 0.15s',
              }}
              onClick={() => navigate(card.path)}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 8px 24px var(--sat-shadow)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = ''
                e.currentTarget.style.boxShadow = ''
              }}
            >
              <Group justify="space-between" mb="md">
                <ThemeIcon size={48} radius="xl" variant="light" color={card.color}>
                  {card.icon}
                </ThemeIcon>
                <ChevronRight size={18} color="var(--sat-text-muted)" />
              </Group>
              <Text fw={700} c="var(--sat-text)" mb={4}>{card.title}</Text>
              <Text size="sm" c="var(--sat-text-muted)">{card.description}</Text>
            </Paper>
          ))}
        </SimpleGrid>
      </Stack>
    </Container>
  )
}
